module.exports = __webpack_public_path__ + "img/top.09c5ba02.jpg";